/* BRINUTI – színváltó a termékkártyákon (kollekció, keresés, főoldali
   „Legkelendőbb" sáv, termékoldali „Hasonló borítók" sávok)

   A meglévő kártyákra (lásd FAJTAK) két dolgot tesz rá, ha a naplónak van
   adata:
     1. a kép alá pöttyöket (a Teeinblue saját bélyegképeivel);
     2. pöttyre kattintva a kártya képe helyben átvált arra a borítóra.

   GYORS VÁLTOZAT (2026-09-27). Korábban a borítót a böngésző rakta össze a
   Teeinblue nagy felbontású rétegeiből: a Naplók oldalon ez 15–20 MB
   letöltés és kb. 10 mp processzormunka volt, telefonon a pöttyök egyenként,
   lassan jelentek meg, és egy kattintás 0,5–6 mp-ig tartott. Most a borítók
   előre legyártott képek: naplónként EGY képcsík (assets/bsvs-<handle>-
   <ver>.webp, átlag 50 KB), benne egymás mellett a pöttyök sorrendjében a
   változatok (legfeljebb 6). Kattintásra csak a csík látható része tolódik
   el — nincs letöltés, nincs összerakás.

   Az adat egyetlen kis fájl (assets/bsv-pottyok.json): naplónként a pöttyök
   (bélyegkép, szín, név), a változatok száma, a csík neve (elhagyható: ha a
   változat a kártya képén nem látszik, pl. a fotós borítónál, csík nélkül
   a pötty csak a linket állítja) és a termékoldalon alapból kijelölt
   változat. Hogy hol van, azt a layout adja át (#bsv-adat).

   A kártya linkjei viszik a választást (?valtozat=<név>), a termékoldalon a
   brinuti-szinvalto-pdp.js ugyanazt jelöli ki a Teeinblue-ban.

   A kártya maga érintetlen marad, amíg senki nem kattint: induláskor a téma
   saját termékképe látszik. Ha nincs adat vagy a JS nem fut, semmi nem
   változik. Szűrés, rendezés és lapozás után a téma újrarajzolja a rácsot —
   az új kártyákat egy MutationObserver veszi fel. */
(function () {
  var forras = document.getElementById('bsv-adat');
  if (!forras) return;
  var beall;
  try { beall = JSON.parse(forras.textContent); } catch (e) { return; }
  if (!beall || !beall.index) return;

  var MAX_POTTY = 6;
  var TEE = 'https://cdn.teeinblue.com/users/40525/';
  /* A képcsíkok a téma assets mappájában vannak, a pöttylista mellett. */
  var CSIK = new URL('.', new URL(beall.index, location.href)).href;

  /* Gyors kapcsolaton a látható kártyák képcsíkja előre, csendben letöltődik,
     így az első kattintás is azonnali. Lassú vagy adattakarékos kapcsolaton
     csak akkor, ha a látogató a pöttyökhöz ér. */
  var kapcsolat = navigator.connection || {};
  var elore = !kapcsolat.saveData && !/(^|-)2g$|^3g$/.test(kapcsolat.effectiveType || '');

  var adat = null;

  function handle(kartya) {
    var a = kartya.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }

  /* Hol vannak termékkártyák. kartya: a kártya gyökere (erre kerül a
     data-bsv és a bsv--kesz); kep: a doboz, ami fölé a borító kerül (az
     első, ami megvan); utan: ami után a pöttyök sora jön.
       - kollekció és keresés: a téma product-card rácsa;
       - főoldal: „Legkelendőbb" sáv (brinuti-legkelendobb);
       - termékoldal: „Hasonló borítók" sávok (brinuti-hasonlo-boritok).
     A két saját sávban az egész kártya egy <a>, ezért a pöttyök a link UTÁN
     jönnek (gomb nem lehet linkben). */
  var FAJTAK = [
    { kartya: '#MainContent .product-grid product-card', kep: ['.card-gallery slideshow-container', '.card-gallery'], utan: '.card-gallery' },
    { kartya: 'li.brinuti-toplista__elem', kep: ['.brinuti-toplista__kep'], utan: '.brinuti-toplista__kartya' },
    { kartya: 'li.brinuti-hasonlo__elem', kep: ['.brinuti-hasonlo__kep'], utan: '.brinuti-hasonlo__kartya' }
  ];
  var fajtaja = typeof WeakMap === 'function' ? new WeakMap() : null;
  function fajta(kartya) { return (fajtaja && fajtaja.get(kartya)) || FAJTAK[0]; }

  /* A pöttyök sora egy rács/sáv MINDEN kártyáján lefoglalja a helyét (üresen
     is), hogy egy sorban a nevek és az árak egy vonalba essenek. Ahol a
     rácsban egyetlen színváltós napló sincs (pl. kiegészítők), ott nem. */
  function helyfoglalo(kartya) {
    var utan = kartya.querySelector(fajta(kartya).utan);
    if (!utan) return null;
    var sor = document.createElement('div');
    sor.className = 'bsv-pottyok';
    sor.setAttribute('aria-hidden', 'true');
    utan.insertAdjacentElement('afterend', sor);
    kartya.classList.add('bsv-sorral');
    return sor;
  }

  /* A rács vagy sáv, amibe a kártya tartozik (a téma rácsában a kártya egy
     <li>-ben ül, a saját sávokban maga a kártya az <li>). */
  function csoport(k) { return k.parentElement && k.parentElement.closest('ul, .product-grid'); }

  /* Hogy egy kártyát már feldolgoztunk-e, azt NEM attribútummal jegyezzük
     meg: telefonon a téma a kártyát néha lecseréli egy másolatára, ami az
     attribútumot is örökli. A WeakSet csak a konkrét elemet ismeri. */
  var feldolgozott = typeof WeakSet === 'function' ? new WeakSet() : null;

  var latszik = 'IntersectionObserver' in window && elore
    ? new IntersectionObserver(function (bejegyzesek) {
        bejegyzesek.forEach(function (b) {
          if (!b.isIntersecting) return;
          latszik.unobserve(b.target);
          betoltCsik(b.target);
        });
      }, { rootMargin: '300px 0px' })
    : null;

  /* Egy rács/sáv, amelyben már van színváltós napló (ott minden kártya
     kap pötty-sort, hogy a sorok egy vonalban maradjanak). */
  var adatosCsoportok = typeof WeakSet === 'function' ? new WeakSet() : null;

  /* Három lépésben, hogy az oldal elrendezését csak EGYSZER kelljen
     kiszámolni: (1) minden új kártyára felkerül az üres sor, (2) csoportonként
     egyszer megmérjük, milyen széles egy sor, (3) megépülnek a pöttyök.
     Kártyánkénti mérés esetén telefonon ez másodpercekig tartott. */
  function felvesz() {
    if (!adat) return;
    var ujak = [];
    FAJTAK.forEach(function (f) {
      [].forEach.call(document.querySelectorAll(f.kartya), function (k) {
        if (feldolgozott ? feldolgozott.has(k) : k.hasAttribute('data-bsv')) return;
        if (feldolgozott) feldolgozott.add(k);
        if (fajtaja) fajtaja.set(k, f);
        var h = handle(k);
        ujak.push({ k: k, h: h && adat[h] ? h : '', cs: csoport(k), f: f });
      });
    });
    if (!ujak.length) return;

    // (1) jelölés és üres sorok
    ujak.forEach(function (u) {
      if (u.h && u.cs && adatosCsoportok && !adatosCsoportok.has(u.cs)) {
        adatosCsoportok.add(u.cs);
        /* Ha a csoport most kapta az első színváltós naplóját, a korábban
           feldolgozott kártyái is kapjanak üres sort. */
        [].forEach.call(u.cs.querySelectorAll(u.f.kartya), function (k) {
          if (k.hasAttribute('data-bsv') && !k.querySelector('.bsv-pottyok')) helyfoglalo(k);
        });
      }
    });
    ujak.forEach(function (u) {
      var k = u.k;
      /* Másolatból örökölt maradványok eltakarítása. */
      k.querySelectorAll('.bsv-keret, .bsv-pottyok').forEach(function (e) { e.parentNode.removeChild(e); });
      k.classList.remove('bsv--kesz', 'bsv--valt', 'bsv-sorral');
      k._bsvCsik = null;
      k.setAttribute('data-bsv', u.h);
      if (u.cs && (!adatosCsoportok || adatosCsoportok.has(u.cs))) helyfoglalo(k);
    });

    // (2) egy mérés csoportonként (egy rácsban minden sor egyforma széles).
    /* A window.innerWidth telefonon szintén újraszámoltatja az elrendezést,
       ezért ezt is csak egyszer olvassuk ki. */
    var keskeny = window.innerWidth < 750;
    var szelesseg = typeof Map === 'function' ? new Map() : null;
    ujak.forEach(function (u) {
      if (!u.h) return;
      var sor = u.k.querySelector('.bsv-pottyok');
      if (!sor) return;
      var kulcs = u.cs || sor;
      if (szelesseg && szelesseg.has(kulcs)) { u.sz = szelesseg.get(kulcs); return; }
      /* A még üres sor középre igazított elrendezésben 0 széles lehet, ezért
         a tárolóját mérjük (tableten a kártya két hasábos, ott a kép kicsi,
         a sor viszont a szöveges hasábban széles). */
      u.sz = (sor.parentElement && sor.parentElement.clientWidth) || 150;
      if (szelesseg) szelesseg.set(kulcs, u.sz);
    });

    // (3) pöttyök
    ujak.forEach(function (u) {
      if (!u.h) return;
      pottyok(u.k, adat[u.h], u.sz, keskeny);
      if (latszik) latszik.observe(u.k);
    });
  }

  /* A képcsík betöltése (egyszer kártyánként). A kész kép a kártya képe fölé
     kerül, de csak akkor látszik, ha a látogató pöttyre kattintott. */
  function betoltCsik(kartya, kesz) {
    var d = adat[kartya.getAttribute('data-bsv')];
    if (!d) return;
    /* Képcsík nélküli napló (nincs „s" a pöttyadatban): a fotós borítón a szín
       csak a borító élén látszik, a kártya képe váltáskor nem változna, ezért
       nincs mit letölteni és a kártya fölé sem kerül semmi. A pötty csak
       kijelöl és a linket állítja (a termékoldalon a szín előre kijelölve),
       a rámutatásos hátlap pedig mindig a téma saját működése szerint jön be. */
    if (!d.s) { if (kesz) kesz(); return; }
    if (kartya._bsvCsik) {
      if (kesz) { if (kartya._bsvCsik.betoltve) kesz(); else kartya._bsvCsik.varok.push(kesz); }
      return;
    }
    var allapot = kartya._bsvCsik = { betoltve: false, varok: kesz ? [kesz] : [] };
    var url = CSIK + d.s;
    var kep = new Image();
    kep.decoding = 'async';
    /* Ha most kell (pöttyre kattintottak, vagy a színszűrő váltja), magas
       prioritással kérjük: különben alacsony prioritású képként a kártyák
       saját képei mögé sorolódik, és görgetés közben másodpercekig várt
       (2026-10-14, lemérve). Az előtöltés (még nem kell) marad alacsony. */
    if (kesz) kep.fetchPriority = 'high';
    /* A képet a betöltés után még ki is csomagoltatjuk (decode), mielőtt
       kész-nek jelölnénk: különben az első váltáskor a böngésző a
       rajzoláskor csomagolná ki a 2880 px-es csíkot, és telefonon ez
       érezhető akadás (gyorsítás, 2026-10-02). */
    kep.onload = function () {
      if (kep.decode) kep.decode().then(kesz2, kesz2); else kesz2();
    };
    function kesz2() {
      if (allapot.betoltve) return;
      allapot.betoltve = true;
      var hely = null;
      fajta(kartya).kep.some(function (sz) { return (hely = kartya.querySelector(sz)); });
      if (hely && !kartya.querySelector('.bsv-keret')) {
        var keret = document.createElement('div');
        keret.className = 'bsv-keret';
        keret.setAttribute('aria-hidden', 'true');
        var mock = document.createElement('div');
        mock.className = 'bsv-mock';
        mock.style.backgroundImage = 'url("' + url + '")';
        mock.style.backgroundSize = (d.k * 100) + '% 100%';
        keret.appendChild(mock);
        hely.appendChild(keret);
      }
      allapot.varok.splice(0).forEach(function (f) { f(); });
    }
    kep.onerror = function () { allapot.varok = []; /* marad a téma képe */ };
    kep.src = url;
  }

  function mutat(kartya, i) {
    var d = adat[kartya.getAttribute('data-bsv')];
    var mock = kartya.querySelector('.bsv-mock');
    if (!d || !mock) return;
    mock.style.backgroundPosition = (d.k > 1 ? (i / (d.k - 1)) * 100 : 0) + '% 0';
    kartya.classList.add('bsv--kesz');
  }

  function pottyok(kartya, d, szeles, keskeny) {
    var sor = kartya.querySelector('.bsv-pottyok') || helyfoglalo(kartya);
    if (!sor) return;
    sor.removeAttribute('aria-hidden');
    sor.setAttribute('role', 'group');
    sor.setAttribute('aria-label', 'Borító-változatok');
    var linkek = [].slice.call(kartya.querySelectorAll('a[href*="/products/"]'));
    var gombok = [];
    var keres = 0;

    function linkre(o) {
      if (!o[2]) return;
      linkek.forEach(function (a) {
        var u = new URL(a.getAttribute('href'), location.origin);
        u.searchParams.set('valtozat', o[2]);
        a.setAttribute('href', u.pathname + u.search + u.hash);
      });
    }
    var kezdo = d.d >= 0 && d.d < d.k ? d.d : -1;
    if (kezdo >= 0) linkre(d.o[kezdo]);

    /* Annyi pötty, amennyi egy sorba belefér; ha nem fér ki mind, az utolsó
       hely a „+N"-é. A csíkban csak az első MAX_POTTY változat van. */
    var gomb = keskeny ? 24 : 26, koz = keskeny ? 7 : 6;
    var fer = Math.max(3, Math.floor(((szeles || 150) + koz) / (gomb + koz)));
    var db = Math.min(d.k, MAX_POTTY);
    var latszo = Math.min(db, d.n <= fer ? d.n : fer - 1);

    /* Ha a látogató a pöttyökhöz ér (egér vagy ujj), a csík már indul —
       mire kattint, jó eséllyel meg is jött. */
    function elokeszit() { betoltCsik(kartya); }
    sor.addEventListener('pointerenter', elokeszit, { once: true });
    sor.addEventListener('touchstart', elokeszit, { once: true, passive: true });

    d.o.slice(0, latszo).forEach(function (o, i) {
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'bsv-potty';
      b.setAttribute('aria-label', (i + 1) + '. változat');
      b.setAttribute('aria-pressed', i === kezdo ? 'true' : 'false');
      if (o[0]) {
        var im = document.createElement('img');
        var teljes = /^https?:/.test(o[0]) ? o[0] : TEE + o[0];
        /* PageSpeed (2026-10-02): a 26 px-es pöttybe eddig a Teeinblue
           „_large” képe jött — ez akár 874–2048 px és 86 KB. Ugyanannak a
           képnek van 100 px-es „_thumbnail” változata (mind a 190-et
           ellenőriztem), 2× kijelzőn is bőven elég. Ha mégsem jönne meg,
           a nagy képre esünk vissza. */
        var kicsi = teljes.replace(/(\/images\/[^/?]+)_large\.webp/, '$1_thumbnail.webp');
        im.src = kicsi;
        im.alt = '';
        im.loading = 'lazy';
        im.width = 26;
        im.height = 26;
        /* Ha a bélyegkép nem jön meg (a Teeinblue-ban törölték), ne törött
           kép látsszon: a pötty a változat színét kapja. */
        im.onerror = function () {
          if (kicsi !== teljes && im.src.indexOf('_thumbnail.webp') !== -1) {
            im.src = teljes;
            return;
          }
          if (im.parentNode) im.parentNode.removeChild(im);
          if (o[1]) b.style.background = o[1];
        };
        b.appendChild(im);
      } else if (o[1]) {
        b.style.background = o[1];
      }
      b.addEventListener('click', function (e) {
        /* A kártyát egy teljes felületű link fedi: a kattintás ne vigyen át
           a termékoldalra. */
        e.preventDefault();
        e.stopPropagation();
        valaszt(i);
      });
      gombok.push(b);
      sor.appendChild(b);
    });

    /* A változat kiválasztása — a pötty is ezt hívja, és a kollekció
       színszűrője is (brinuti-szinszuro): az a csík bármelyik változatára
       válthat, akkor is, ha a pöttye nem fért ki a sorba. */
    function valaszt(i) {
      if (i < 0 || i >= db) return;
      gombok.forEach(function (x, j) { x.setAttribute('aria-pressed', j === i ? 'true' : 'false'); });
      linkre(d.o[i]);
      var ez = ++keres;
      kartya.classList.add('bsv--valt');
      betoltCsik(kartya, function () {
        if (ez !== keres) return; // közben másikra kattintottak
        mutat(kartya, i);
        kartya.classList.remove('bsv--valt');
      });
    }
    /* Vissza a téma saját képére (a szűrő törlésekor). */
    function alap() {
      ++keres;
      gombok.forEach(function (x, j) { x.setAttribute('aria-pressed', j === kezdo ? 'true' : 'false'); });
      linkek.forEach(function (a) {
        var u = new URL(a.getAttribute('href'), location.origin);
        u.searchParams.delete('valtozat');
        a.setAttribute('href', u.pathname + u.search + u.hash);
      });
      if (kezdo >= 0) linkre(d.o[kezdo]);
      kartya.classList.remove('bsv--kesz', 'bsv--valt');
    }
    kartya._bsvValaszt = valaszt;
    kartya._bsvAlap = alap;

    if (d.n > latszo) {
      var tobb = document.createElement('span');
      tobb.className = 'bsv-tobb';
      tobb.textContent = '+' + (d.n - latszo);
      tobb.setAttribute('title', 'További ' + (d.n - latszo) + ' változat a termékoldalon');
      sor.appendChild(tobb);
    }
  }

  /* Szűrés, rendezés, végtelen görgetés és a később betöltődő sávok után
     újra körülnézünk — képkockánként legfeljebb egyszer. */
  var utemezve = false;
  function figyel() {
    if (!('MutationObserver' in window)) return;
    new MutationObserver(function () {
      if (utemezve) return;
      utemezve = true;
      requestAnimationFrame(function () { utemezve = false; felvesz(); });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* Alapértelmezett fetch (credentials: same-origin): ez egyezik a layout
     <link rel="preload" crossorigin="anonymous"> előtöltésével. */
  fetch(beall.index)
    .then(function (r) { if (!r.ok) throw r; return r.json(); })
    .then(function (j) { adat = j; felvesz(); figyel(); })
    .catch(function () { /* marad minden a téma szerint */ });
})();
